import React from "react";
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Loader from '../components/Loader';

const AdminProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading, isAdminUser } = useAuth();
  if (isLoading) {
    return <Loader />;
  }
  
  if (isAuthenticated) {
    if(!isAdminUser) {
      return <Navigate to="/error/401" />;  
    } else {
      return children;
    }
  } else {
    return <Navigate to="/login" />; // Admin User is not authenticated, redirect to login
  }
};

export default AdminProtectedRoute;